<template>
  <v-snackbar v-if="pending" :value="true" top :timeout="-1" class="recording-recovery-banner">
    <div class="d-flex align-center">
      <v-icon color="warning" class="mr-2">mdi-alert-circle-outline</v-icon>
      <span>
        Encontramos uma gravação não enviada da sessão de
        <strong>{{ pending.customerName || 'um paciente' }}</strong>.
      </span>
    </div>
    <template v-slot:action>
      <v-btn text small color="primary" @click="recover">Recuperar</v-btn>
      <v-btn text small color="error" @click="discard">Descartar</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import RecordingStorage from "@/api/RecordingStorage";

export default {
  data() {
    return {
      pending: null,
    };
  },

  async created() {
    try {
      const all = await RecordingStorage.getAllMeta();
      if (all.length) {
        this.pending = all.sort((a, b) => b.updatedAt - a.updatedAt)[0];
      }
    } catch (err) {
      console.error('Falha ao verificar gravações pendentes:', err);
    }
  },

  methods: {
    recover() {
      const sessionId = this.pending.session_id;
      this.pending = null;
      this.$store.dispatch('recorder/setPendingReopen', sessionId);
    },

    async discard() {
      const sessionId = this.pending.session_id;
      this.pending = null;
      try {
        await RecordingStorage.remove(sessionId);
      } catch (err) {
        console.error('Falha ao descartar gravação pendente:', err);
      }
    },
  },
};
</script>

<style scoped>
.recording-recovery-banner {
  z-index: 250;
}

.recording-recovery-banner ::v-deep .v-snackbar__wrapper {
  border-radius: 16px !important;
}
</style>
